<form [formGroup]="parent.configuration">
  <header [ngClass]="[parent.configuration.get('isPublic')?.value ? '' : 'unpublished']">
    <inline-editor-lib
      [viewHeader]="parent.isNewConfig ? 'New template ' : 'Editing: '"
      [editHeader]="'Editing: '"
      [allowEdit]="!parent.isNewConfig"
      formControlName="name"
      [showEditIcon]="parent.configuration.get('name').value.length > 0 && !parent.isNewConfig"
      placeholder="e.g. Formatted CV"
      editIconTooltip="Edit template name"
    ></inline-editor-lib>
    <aside>
      <mat-slide-toggle
        formControlName="isPublic"
        [matTooltip]="
          parent.configuration.get('isPublic')?.value ? 'Unpublish template' : 'Publish template to all users within your corporation'
        "
        matTooltipShowDelay="500"
      >
        {{ parent.configuration.get('isPublic')?.value ? 'PUBLISHED' : 'UNPUBLISHED' }}
      </mat-slide-toggle>
      @if (parent.canCopyDirectLink) {
        <mat-icon
          fontIcon="link"
          (click)="copyDirectLink.emit()"
          matTooltip="Copy direct link for a Bullhorn Action menu item"
          matTooltipShowDelay="500"
        ></mat-icon>
      }
      @if (!parent.isNewConfig) {
        <mat-icon fontIcon="delete_outline" (click)="delete.emit()" [matTooltip]="'Delete Template'" matTooltipShowDelay="500"></mat-icon>
      }
      <mat-icon fontIcon="close" (click)="discardLocalChanges.emit()" matTooltip="Close" matTooltipShowDelay="500"></mat-icon>
    </aside>
  </header>
</form>
<form [formGroup]="parent.form">
  <mat-tab-group mat-align-tabs="start" dynamicHeight="true" mat-stretch-tabs="false">
    <mat-tab label="Configuration">
      <ng-template mat-tab-label>
        <span [ngClass]="parent.configuration.invalid ? 'invalid-tab' : 'valid-tab'">
          Configuration
          <mat-icon [fontIcon]="parent.validationIconConfiguration" [ngClass]="parent.tabsJustLoaded ? 'first-load' : ''"></mat-icon>
        </span>
      </ng-template>
      <form [formGroup]="parent.configuration" class="workflow-config">
        @if (parent.isNewConfig) {
          <section id="new-template-name" class="template-section grey-background">
            <h3>Template name</h3>
            <input type="text" [formControl]="parent.newTemplateName" placeholder="e.g. Formatted CV" />
          </section>
        }
        <section class="template-section basic-flex-container" [ngClass]="{ 'side-by-side-sections': !parent.isNewConfig }">
          <app-entity-type-picker
            [isNewConfig]="parent.isNewConfig"
            [configuration]="parent.configuration"
            [namespace]="parent.workflowConfig.clientNamespace"
            [allowedEntityTypes]="allowedEntityService.getAllowedEntities()"
          ></app-entity-type-picker>
          @if (parent.documentDestinationOptionsAllowed) {
            <app-template-availability
              [isNewConfig]="parent.isNewConfig"
              [workflowType]="parent.workflowConfig.workflow"
              [filtersFormArray]="parent.filtersFormArray"
              [configuration]="parent.configuration"
            ></app-template-availability>
          }
        </section>
        <section id="output-file-container" class="template-section">
          <h3>DocMerge (the output file)</h3>
          <section class="output-file-wrapper">
            <app-output-file-name-section [formGroup]="parent.outputFileNameSectionFormGroup"></app-output-file-name-section>
            <app-document-destination-filetype
              [documentDestinationOptionsAllowed]="parent?.documentDestinationOptionsAllowed"
              [outputFileTypeSectionFormGroup]="parent?.outputFileTypeSectionFormGroup"
              [destinationsForOutputFileType]="parent?.destinationsForOutputFileType"
              [fileTypeOptionsAllowed]="parent?.fileTypeOptionsAllowed"
              [entityType]="parent ? parent.configuration.get('entity').value : null"
              [namespace]="parent.workflowConfig.clientNamespace"
              (updateDocumentForDestinationType)="parent.updateDocumentForDestinationType($event, parent.outputFileTypeSectionFormGroup, parent.destinationsForOutputFileType)"
            >
            </app-document-destination-filetype>
            @if (parent.documentDestinationOptionsAllowed) {
              <app-document-destination
                [configuration]="parent.configuration"
                [isNewConfig]="parent.isNewConfig"
              ></app-document-destination>
            }
          </section>
        </section>
        <app-docmerge-section-list
          [workflowConfigId]="parent.configuration.get('id').value"
          [sections]="parent.getDynamicSections()"
          [expandedSectionIndex]="expandedSectionIndex"
          [entityType]="parent.configuration.get('entity').value"
          [namespace]="parent.workflowConfig.clientNamespace"
          [allCertifications]="allCertifications"
          [allCertificationGroups]="allCertificationGroups"
          [combinedOutput]="combinedOutput"
          (removeSection)="parent.removeDynamicSection($event)"
          (reorderSections)="reorderSections($event)"
        ></app-docmerge-section-list>
        <app-docmerge-add-new-section
          [validationErrors]="parent.sectionsFormArray.errors"
          [allowedSectionTypes]="allowedSectionTypes"
          [disabled]="parent.configuration.get('entity').value === null"
          (addSection)="addSection($event)"
        ></app-docmerge-add-new-section>
      </form>
    </mat-tab>
    @if (parent.showUserRestrictions) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>
            <mat-icon fontIcon="lock_person" class="tab-icon"></mat-icon>
            Restrictions
          </span>
        </ng-template>
        <app-user-restrictions [filters]="parent.filtersFormArray" [entity]="parent.entity"></app-user-restrictions>
      </mat-tab>
    }
    @if (docMergeEnabled$ | async) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="parent.signatureGroup.invalid ? 'invalid-tab' : 'valid-tab'">
            <mat-icon fontIcon="draw" class="tab-icon"></mat-icon>
            Docusign
            @if (parent.signatureGroup.controls['enabled'].value) {
              <mat-icon
                [fontIcon]="parent.validationIconSignatureGroup"
                [ngClass]="parent.tabsJustLoaded ? 'first-load' : ''"
                [matTooltip]="parent.tooltipText"
                matTooltipShowDelay="500"
              ></mat-icon>
            }
          </span>
        </ng-template>
        <app-docusign-tab
          [formGroup]="parent.signatureGroup"
          [namespace]="parent.workflowConfig.clientNamespace"
          [isDocMerge]="true"
          [parent]="parent">
        </app-docusign-tab>
      </mat-tab>
    }
    <mat-tab label="Scripting Box">
      <ng-template mat-tab-label>
        <span>
          <mat-icon fontIcon="code"></mat-icon>
          Scripting box
        </span>
      </ng-template>
      <app-scripting-box
        [formGroup]="parent.scriptingBoxGroup"
        [clientNamespace]="parent.workflowConfig.clientNamespace"
      ></app-scripting-box>
    </mat-tab>
    @if (showActionsTab) {
      <mat-tab label="Actions">
        <ng-template mat-tab-label>
          <span>
            <mat-icon fontIcon="lightbulb"></mat-icon>
            Actions
          </span>
        </ng-template>
        <app-actions
          [formGroup]="parent.actionsGroup"
          [entity]="parent.entity"
          [isDocusignEnabled]="parent.signatureGroup.get('enabled').value"
        ></app-actions>
      </mat-tab>
    }
  </mat-tab-group>
  <section class="footer-btns">
    <button type="button" class="danger-btn-hover" (click)="discardLocalChanges.emit($event)" tabindex="0" appRipple>cancel</button>
    <button
      type="submit"
      (click)="saveWorkflowConfig.emit()"
      [disabled]="!parent.allowSave"
      [title]="
        parent.allowSave
          ? parent.configuration.get('isPublic')?.value
            ? 'Save template as published (available to all users within your corporation)'
            : 'Save template as unpublished'
          : ''
      "
      tabindex="0"
      appRipple
    >
      <mat-icon>{{ parent.configuration.get('isPublic')?.value ? 'public' : 'public_off' }}</mat-icon>
      save as {{ parent.configuration.get('isPublic')?.value ? 'PUBLISHED' : 'UNPUBLISHED' }}
      <mat-icon class="watermark">{{ parent.configuration.get('isPublic')?.value ? 'public' : 'public_off' }}</mat-icon>
    </button>
  </section>

  <!--  <pre style="margin-top:20px;"><span style="color: white; background-color: slategray;">{{this.parent.form.value | json}} | valid={{this.parent.form.valid}}, dirty={{this.parent.form.dirty}}</span></pre>-->
</form>
